import React, { useEffect, useState } from 'react';
import './PopupCard.css';
import {useTranslation} from "react-i18next";

export interface PopupCardProps {
  onClose?: () => void;
  visibility?: boolean;
}

const DEFAULT_DURATION = 8000;


// Public assets live under /public, can be referenced directly from root
const LEFT_ICON = '/images/ui-svg/warning-blue.svg';
const CLOSE_ICON = '/images/ui-svg/close_blue.svg';

const PopupCard: React.FC<PopupCardProps> = ({ onClose, visibility = false }) => {
  const {t} = useTranslation();
  const NAMES = t('subscription.names').split(',');
  const SUBTEXT = t('subscription.subtext').split('|');
  const [visible, setVisible] = useState(visibility);
  const [viewTitle] = useState(`${NAMES[Math.random() * NAMES.length | 0]} ${t('subscription.popupTitle')}`);
  const [description] = useState(SUBTEXT[Math.random() * SUBTEXT.length | 0]);

  useEffect(() => {
    // defer to next tick to allow CSS transition to run
    if (!visibility) return;
    const id = requestAnimationFrame(() => setVisible(visibility));
    setTimeout(() => setVisible(false), DEFAULT_DURATION);
    return () => cancelAnimationFrame(id);
  }, [visibility]);

  const handleClose = () => {
    // allow slide-out animation before unmounting (parent can unmount after callback)
    setVisible(false);
    if (onClose) {
      // give 250ms for animation to complete
      setTimeout(onClose, 250);
    }
  };

  return (
    <div className={`popup-card ${visible ? 'popup-card--enter' : ''}`} role="alert" aria-live="polite">
      <img className="popup-card__left-icon" src={LEFT_ICON} alt="info" />
      <div className="popup-card__content">
        <div className="popup-card__title">👉 {viewTitle} 🚀</div>
        {description && <div className="popup-card__description">{description}</div>}
      </div>
      <button className="popup-card__close" aria-label="Close notification" onClick={handleClose}>
        <img src={CLOSE_ICON} alt="close"/>
      </button>
    </div>
  );
};

export default PopupCard;
